<template>
  <div class="pay-order-new">
    <div class="title">订单支付</div>
    <div class="order-title">订单详情</div>
    <div class="order-info">
      <div>
        <span>订单编号</span>
        <span class="val">{{orderInfo.orderNo}}</span>
      </div>
      <div>
        <span>订单状态</span>
        <span class="val">{{orderInfo.statusName}}</span>
      </div>
      <div>
        <span>下单时间</span>
        <span class="val">{{orderInfo.orderTime}}</span>
      </div>
      <div>
        <span>联系号码</span>
        <span class="val">{{orderInfo.contactMobile}}</span>
      </div>
    </div>
    <el-table :data="list" :header-cell-style="{background:'#9B232A', color: '#FFFFFF'}" border>
      <template v-if="moduleType === 'HOTEL'">
        <el-table-column prop="merchIndustryName" label="酒店名称" align="center"></el-table-column>
        <el-table-column prop="useStartDate" label="入离时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.useStartDate}} ~ {{scope.row.useEndDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="房型" align="center"></el-table-column>
      </template>
      <template v-else>
        <el-table-column prop="merchIndustryName" label="餐厅名称" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="产品名称" align="center"></el-table-column>
        <el-table-column prop="bookDate" label="预定时间" align="center"></el-table-column>
      </template>
      <el-table-column prop="unitPrice" label="单价" align="center">
        <template slot-scope="scope">
          <span>¥{{scope.row.unitPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量" align="center"></el-table-column>
    </el-table>
    <div class="buy-div">
      <!-- <span class="font12 mr10">数量</span>
      <span>共</span>
      <span class="text-green">{{orderInfo.quantity}}</span>
      <span>间</span>
      <span class="text-green">{{orderInfo.stayDays}}</span>
      <span>晚</span> -->
      <span class="ml40 font12 mr10">总价</span>
      <span class="price">¥{{ orderInfo.paymentTotal }}</span>
      <div class="buy-btn" @click="handleToPay">立即支付</div>
    </div>
    <div class="timer-div" v-if="rocallTime">
      <span>支付时间剩余</span>
      <span class="timer">{{rocallTime}}</span>
      <span>，超时后将自动取消订单</span>
    </div>
    <!-- 支付弹框 -->
    <payDialog ref="payDialog" />
  </div>
</template>

<script>
import { orderInfo, getSysTime } from '@/api/pay'
import PayDialog from '@/components/payDialog'
import { formatDate } from '@/utils/validate'
export default {
  data () {
    return {
      loading: false,
      orderNo: null,
      orderInfo: {},
      list: [],
      rocallTime: null
    }
  },
  components: {
    'payDialog': PayDialog
  },
  created () {
    this.orderNo = this.$route.query.orderNo
    this.moduleType = this.$route.query.moduleType
    this.getOrderInfo()
  },
  methods: {
    handleToPay () {
      if (this.flag) return
      this.flag = true
      this.$refs.payDialog.toPay(this.orderNo, this.moduleType)
    },
    getOrderInfo () {
      orderInfo(this.orderNo, this.moduleType).then(res => {
        if (res.code === 0) {
          this.orderInfo = res.data
          res.data.bookDate = formatDate('yyyy-MM-dd', new Date())
          this.list.push(res.data)
          this.getSysTime(res.data.expire)
        }
      })
    },
    getSysTime (expire) {
      getSysTime().then(res => {
        if (res.code === 0 && res.data && res.data.sysTime) {
          // 支付倒计时
          const ts = new Date(expire.replace(/-/g, '/')).getTime()
          const tc = new Date(res.data.sysTime.replace(/-/g, '/')).getTime()
          this.runBack(ts - tc)
        } else {
          const ts = new Date(expire.replace(/-/g, '/')).getTime()
          const tc = new Date().getTime()
          this.runBack(ts - tc)
        }
      })
    },
    runBack (cm) {
      const minutes = new Date(cm).getMinutes()
      const seconds = new Date(cm).getSeconds()
      if (cm > 0) {
        // 超过60秒，展示分秒
        if (cm > 60000) {
          const m = minutes < 10 ? '0' + minutes : minutes
          const s = seconds < 10 ? '0' + seconds : seconds
          this.rocallTime = m + '分' + s + '秒'
        } else {
          // 只展示秒
          const s = seconds < 10 ? '0' + seconds : seconds
          this.rocallTime = s + '秒'
        }
        setTimeout(() => {
          cm -= 1000
          this.runBack(cm)
        }, 1000)
      } else {
        // 取消订单
        this.$refs.payDialog.cancelOrder(this.orderNo, this.moduleType)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pay-order-new{
  width: 1279px;
  background: #FFFFFF;
  box-shadow: 0 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;
  padding: 40px;
  margin-top: 24px;
  overflow-x: auto;
  .title{
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    color: #9B232A;
    padding-bottom: 40px;
    border-bottom: 1px solid #8FA8BC;
  }
  .order-title{
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    color: #424855;
    margin-top: 30px;
  }
  .order-info{
    margin: 20px 0 12px 0;
    display: flex;
    // justify-content: space-around;
    div{
      // width: 25%;
      font-size: 16px;
      line-height: 24px;
      color: #9FA1B0;
      margin-right: 100px;
      white-space: nowrap;
      .val {
        margin-left: 30px;
        color: #44516F;
      }
    }
  }
  .buy-div{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 86px;
    span{
      font-size: 20px;
      font-weight: bold;
      color: #424855;
      margin-right: 2px;
    }
    .font12{
      font-weight: 400;
      font-size: 12px;
      color: #687280;
      margin-right: 10px;
    }
    .ml40{
      margin-left: 40px;
    }
    .price{
      color: #FF0000;
    }
    .buy-btn{
      width: 140px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #9B232A;
      opacity: 1;
      border-radius: 4px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      margin-left: 30px;
      cursor: pointer;
    }
  }
  .timer-div{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 12px;
    font-size: 14px;
    line-height: 19px;
    color: #424855;
    .timer{
      color: #FF0000;
      margin: 0 8px;
    }
  }
}
</style>
